import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid, { GridProps } from '@material-ui/core/Grid'

interface Props extends GridProps {
  rounded?: boolean
  columns: Array<{
    value: React.ReactNode
    label: React.ReactNode
  }>
}

const styles = (theme: Theme) => {
  const clipPath = `
    polygon(
      0% ${theme.notchSize},
      ${theme.notchSize} 0%,
      calc(100% - ${theme.notchSize}) 0%,
      100% ${theme.notchSize},
      100% 100%,
      0% 100%
    )
  `

  return createStyles({
    root: {
      height: 55,
      backgroundColor: '#FFFFFF',
      clipPath,
      '-webkit-clip-path': clipPath,
    },
    rounded: {
      borderBottomLeftRadius: 2,
      borderBottomRightRadius: 2,
    },
    separator: {
      width: 1,
      height: '100%',
      opacity: .1,
      background: `
        linear-gradient(
          to bottom,
          transparent,
          black,
          transparent
        )
      `
    },
    label: {
      opacity: .35,
      fontSize: 10,
      fontWeight: 500,
      textTransform: 'uppercase',
    },
    padded: {
      paddingLeft: 8,
      paddingRight: 8,
    },
  })
}

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardScores: React.SFC<InjectedProps> = ({
  classes,
  className,
  rounded,
  columns,
  ...props
}) => {
  return (
    <Grid
      className={classNames(className, classes.root, { [classes.rounded]: rounded })}
      alignItems="center"
      direction="row"
      wrap="nowrap"
      container
      {...props}
    >
      {
        columns.map((column, i) => (
          <React.Fragment key={`column-${i}`}>
            <Grid className={classes.padded} zeroMinWidth xs item>
              <Grid alignItems="center" direction="column" container>
                <Grid zeroMinWidth xs item>
                  {column.value}
                </Grid>
                <Grid zeroMinWidth xs item>
                  <Typography className={classes.label} noWrap>
                    {column.label}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {columns.length > 1 && i < columns.length - 1 && (
              <Grid className={classes.separator} item />
            )}
          </React.Fragment>
        ))
      }
    </Grid>
  )
}

export default withStyles(styles)(GameCardScores)
